import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyNose = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.2917 19.3425C14.5667 19.8754 14.9654 20.3345 15.4544 20.6815C15.9434 21.0284 16.5085 21.2531 17.1023 21.3366C17.696 21.42 18.3012 21.3599 18.8669 21.1612C19.4326 20.9625 19.9425 20.6311 20.3537 20.1947C20.7648 19.7583 21.0654 19.2296 21.2301 18.6531C21.3948 18.0766 21.4188 17.4689 21.3002 16.8812C21.1816 16.2934 20.9237 15.7427 20.5483 15.2752C20.1729 14.8076 19.6908 14.4369 19.1426 14.1942C18.514 13.916 17.9495 13.5112 17.4843 13.0051C17.0192 12.4989 16.6634 11.9023 16.4392 11.2525C15.5882 8.67047 15.1468 5.97111 15.1309 3.2525C15.1309 3.0475 15.1251 2.83584 15.1251 2.6275"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.87501 2.625C8.87501 2.83583 8.87501 3.04167 8.86918 3.25C8.8529 5.96858 8.41145 8.66787 7.56084 11.25C7.33666 11.8998 6.98089 12.4964 6.51575 13.0026C6.05062 13.5087 5.48612 13.9135 4.85751 14.1917C4.30958 14.4346 3.82786 14.8053 3.45273 15.2728C3.07759 15.7403 2.81998 16.2908 2.70147 16.8784C2.58296 17.4659 2.60702 18.0733 2.77161 18.6496C2.93621 19.226 3.23656 19.7545 3.64748 20.1908C4.05841 20.6271 4.56793 20.9586 5.13336 21.1575C5.69879 21.3563 6.30364 21.4167 6.89723 21.3336C7.49082 21.2506 8.05584 21.0264 8.54495 20.68C9.03406 20.3335 9.433 19.8749 9.70834 19.3425"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 18.25C14.5 18.25 14.5 20.125 12 20.125C9.5 20.125 9.5 18.25 7 18.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyNose.displayName = 'SvgBodyNose';
export default SvgBodyNose;
